import { gql } from '@apollo/client';
import { AssetWithDimensionsFragment } from '../../graphql/fragments/Asset';

export const ContentCardFragment = gql`
  fragment ContentCardFragment on ContentCard {
    ... on ContentCard {
      backgroundColor
      ctas {
        id
        ctaStyle
        displayLinked
        showIcon
        text
        title
        url
      }
      customBackgroundColor
      secondaryHeader
      header
      primaryHeaderPosition
      secondaryHeaderPosition
      subheaderPosition
      ctaPosition
      iconPosition
      horizontalTextAlignment
      internalSpace {
        mobile
        tablet
        desktop
      }
      icon {
        file {
          details {
            image {
              height
              width
            }
          }
          fileName
          url
        }
        id
        title
      }
      id
      image {
        ...AssetWithDimensionsFragment
      }
      desktopImage {
        ...AssetWithDimensionsFragment
      }
      tabletImage {
        ...AssetWithDimensionsFragment
      }
      mobileImage {
        ...AssetWithDimensionsFragment
      }
      subheader
      cardTextColor: textColor
      invertImageTextColor
      cardTextPosition: textPosition
      title
      ctaLayout
      settings {
        ... on HeaderStyleSetting {
          id
          contentType
          title
          affectedHeader
          headerFont
          relativeToBrowserWidth
          headerLetterSpacing {
            mobile
            tablet
            desktop
          }
          headerLineHeight {
            mobile
            tablet
            desktop
          }
          headerSize {
            mobile
            tablet
            desktop
          }
          headerSpaceAfter {
            mobile
            tablet
            desktop
          }
          secondaryHeaderFont
          secondaryHeaderLetterSpacing {
            mobile
            tablet
            desktop
          }
          secondaryHeaderLineHeight {
            mobile
            tablet
            desktop
          }
          secondaryHeaderSize {
            mobile
            tablet
            desktop
          }
          secondaryHeaderSpaceAfter {
            mobile
            tablet
            desktop
          }
        }
        ... on BodyStyleSetting {
          id
          contentType
          title
          bodyFont
          relativeToBrowserWidth
          bodySize {
            mobile
            tablet
            desktop
          }
          bodyLineHeight {
            mobile
            tablet
            desktop
          }
          bodyLetterSpacing {
            mobile
            tablet
            desktop
          }
          bodySpaceAfter {
            mobile
            tablet
            desktop
          }
        }
      }
      headerMaxLineLength
      rowSpan {
        mobile
        tablet
        desktop
      }
      columnSpan {
        mobile
        tablet
        desktop
      }
      hoverEffect
    }
  }
  ${AssetWithDimensionsFragment}
`;

export default {};
